import { mapActions, mapState } from "vuex";
// import ThongTinDieuChinh from "../screen/ThongTinDieuChinh.vue";
import ThongTinDangKy from "@/components/thongtindangky/screen/DangKy.vue";
import { _message } from "@/helpers/_message"
export default {
	components: {
		// ThongTinDieuChinh,
		ThongTinDangKy
	},
	data() {
		return {
			thongtin: { soCmnd: "", regCode: "" },
			isThongTin: false,
			// isTHPT: false,
		};
	},
	computed: {
		...mapState({
			dotdangky: (state) => state.dotdangky.dotdangky,
		})
	},
	methods: {
		...mapActions({
			findThongTinChinhSua: "thisinh/findThongTinChinhSua",
			findThiSinhDKTHPT: "thisinh/findThiSinhDKTHPT",
			getNguyenVongsByThiSinhId: "nguyenvong/getNguyenVongsByThiSinhId",
			getNganhs: "nganh/getNganhs",
			getTinhs: "truong/getTinhs",
		}),
		btnSearch() {
			this.findThongTinChinhSua(this.thongtin).then((response) => {
				if (response.status === 200) {
					this.getNganhs(this.dotdangky.dotDangKyId),
						this.isThongTin = true;
				} else if (response.status === 204) {
					_message.messageDaTrungTuyen();
				} else if (response.status === 403) {
					this.$swal.fire({
						icon: "warning",
						title: response.data.title,
						text: response.data.message,
					});
				} else {
					_message.messageErrorTraCuu();
				}
			});
		},
	},
	async created() {
		let thisinh = this.$store.state.thisinh.thisinh;
		let getInformation = [
			this.$store.commit("nguyenvong/loadNew"),
			this.$store.commit("tohop/loadNew"),
			this.$store.commit("truong/loadNew"),
			this.getTinhs(),
		];
    this.thongtin.soCmnd = thisinh.soCmnd;
		thisinh.thiSinhId
			? (this.thongtin.soCmnd = thisinh.soCmnd)
			: getInformation.push(this.$store.commit("thisinh/loadNew"));
		await Promise.all(getInformation)
			.then(() => { })
			.catch((error) => {
				console.error(error, "error");
			});
	},
	destroyed() {
		this.$store.commit("thisinh/loadNew");
	},
};
